export const caseList = [
  {
    type: 1,
    title: '泰和安智慧工厂',
    subTitle: '泰和安智慧工厂', // 菜单名称
    area: '河北·秦皇岛',
    time: '2023-11-16',
    img: '/images/menu/B1-bg.png',
    icon: '/images/case/icon/icon-1.png',
    content: '工厂目前具有4个生产车间、302台生产设备，25条产线，数智化工厂接入了视频、温湿度传感器、配电设施、流量计、空气质量监测仪、有毒有害气体监测仪、手持PDA等200+物联网采集设备，将工厂的设备情况、能耗情况、视频监控、环境监测、隐患事件和生产进度等全方位管控并进行可视化展示，为企业决策提供了有力的数据支撑。',
    list: [
      {
        type: 'content',
        list: [
          '泰和安成立于2008年，是一家专注于物联网消防产品、消防设备研发、制造、销售、服务为一体的国家级高新技术企业。工厂目前具有4个生产车间、302台生产设备，25条产线，数智化工厂接入了视频、温湿度传感器、配电设施、流量计、空气质量监测仪、有毒有害气体监测仪、手持PDA等200+物联网采集设备，将工厂的设备情况、能耗情况、视频监控、环境监测、隐患事件和生产进度等全方位管控并进行可视化展示，为企业决策提供了有力的数据支撑。'
        ]
      },
      {
        type: 'img',
        imgType: 1,
        colSpan: 24,
        gutter: 0,
        list: [
          '/images/case/case-1-tha/1.png',
          '/images/case/case-1-tha/2.png',
          '/images/case/case-1-tha/3.png'
        ]
      }
    ]
  },
  {
    type: 2,
    title: '贵溪硫磷化工基地安全智能化管控平台',
    subTitle: '贵溪硫磷化工基地安全智能化管控',
    area: '江西·贵溪市',
    time: '2023-04-11',
    img: '/images/menu/B2-bg.png',
    icon: '/images/case/icon/icon-2.png',
    content: '对化工企业从全过程、全要素、全参与方三个方面进行解构，通过数字化、在线化、智能化技术进行重构，形成对监控要素数据的有效利用，构建以新设计、新模式、新服务为代表的全新生产力，最终驱动本市化工企业等相关行业的升级，形成数字化转型下的新产业。',
    list: [
      {
        type: 'content',
        list: [
          '贵溪硫磷化工基地一期占地3.12平方公里，目前为开放式园区，无法有效管控人、车及危险品走向。在实施了设备接入管理平台，企业安全风险智能化管控平台，化工园区安全风险智能化管控平台，政府安全风险智能化监管平台四个平台。贵溪市化工园区安全风险智能化管控平台的建设，是利用云计算、大数据、物联网、移动互联网、人工智能等信息技术，对贵溪市化工企业从全过程、全要素、全参与方三个方面进行解构，通过数字化、在线化、智能化技术进行重构，形成对监控要素数据的有效利用，构建以新设计、新模式、新服务为代表的全新生产力，最终驱动本市化工企业等相关行业的升级，形成数字化转型下的新产业。'
        ]
      },
      {
        type: 'img',
        imgType: 1,
        colSpan: 24,
        gutter: 0,
        list: [
          '/images/case/case-2-gx/1.png',
          '/images/case/case-2-gx/2.png'
        ]
      }
    ]
  },
  {
    type: 2,
    title: '库车经开区化工园区安全风险智能化管控平台',
    img: '/images/menu/B3-bg.png',
    icon: '/images/case/icon/icon-3.png',
    area: '新疆·阿克苏',
    time: '2023-08-29',
    subTitle: '库车经开区化工园区安全风险智能化管控',
    content: '业务信息化，方便了园区管理人员对业务的监督和处理；对于关注的点位均进行了传感器和摄像头的接入，消灭管理死角；将数据统一接入，所有的业务无需切换，直接在系统内都可以查询和检索到，增加了业务管理的便捷性。' ,
    list: [
      {
        type: 'content',
        list: [
          '库车经开区化工园区安全风险智能化管控平台上线后'
        ]
      },
      { // 有序排列
        type: 'order',
        list: [
          {
            index: '（1）',
            title: '业务信息化：',
            content: '之前化工园区和企业的问题都是线下处理，业务流程不透明、业务闭环不到位、传感数据未接入，上了智慧化工园区后，以前的业务都信息化了，方便了园区管理人员对业务的监督和处理；对于关注的点位均进行了传感器和摄像头的接入，消灭了管理死角。'
          },
          {
            index: '（2）',
            title: '数据标准化：',
            content: '之前化工园区和企业的系统及管理方式每家的存储方式不一样，涉及的表单和系统多样，系统切换繁琐，上了智慧化工园区后，将数据统一接入，所有的业务无需切换，直接在系统内都可以查询和检索到，增加了业务管理的便捷性。'
          },
          {
            index: '（3）',
            title: '管理智慧化：',
            content: '之前化工园区和企业的安全管理问题大多凭借老员工的经验判断，有时会因为人员操作不当或处理不及时耽误了安全隐患的及时发现，影响生产进度。上了智慧化工园区后，系统将海量监测和业务数据输入，凭借系统的数据分析，将隐患预警、应急指挥决策通过智能分析方式得出结论，为决策者提供了有力的辅助决策。'
          }
        ]
      },
      {
        type: 'img',
        imgType: 1,
        colSpan: 24,
        gutter: 0,
        list: [
          '/images/case/case-3-kc/1.png',
          '/images/case/case-3-kc/2.png'
        ]
      }
    ]
  },
  {
    type: 2,
    title: '安庆桐城化工园区智慧管理平台',
    img: '/images/menu/B4-bg.png',
    icon: '/images/case/icon/icon-4.png',
    area: '安徽·安庆市',
    time: '2023-05-25',
    subTitle: '安庆桐城化工园区智慧管理平台',
    content: '平台建设坚持以有效防范化解重大安全风险为目标，突出安全基础管理、重大危险源安全管理、安全风险分级管控和隐患排查治理双重预防机制、特殊作业管理、封闭化管理和敏捷应急等基本功能，强化感知、网络、安全等基础设施建设，推进信息共享、上下贯通，推动科技创新、工业互联网产业生态、安全生产在园区内外的渗透及融合发展，实现不同企业、不同部门、不同层级之间的协同联动，助力化工园区安全发展高质量发展。' ,
    list: [
      {
        type: 'content',
        list: [
          '安庆桐城化工园区智慧管理平台建设坚持以有效防范化解重大安全风险为目标，突出安全基础管理、重大危险源安全管理、安全风险分级管控和隐患排查治理双重预防机制、特殊作业管理、封闭化管理和敏捷应急等基本功能，强化感知、网络、安全等基础设施建设，推进信息共享、上下贯通，推动科技创新、工业互联网产业生态、安全生产在园区内外的渗透及融合发展，实现不同企业、不同部门、不同层级之间的协同联动，助力化工园区安全发展高质量发展。'
        ]
      },
      {
        type: 'img',
        imgType: 1,
        colSpan: 24,
        gutter: 0,
        list: [
          '/images/case/case-4-aq/1.png',
          '/images/case/case-4-aq/2.png'
        ]
      }
    ]
  },
  {
    type: 2,
    title: '山东烟台安全生产监管平台项目',
    img: '/images/menu/B5-bg.png',
    icon: '/images/case/icon/icon-5.png',
    area: '山东·烟台',
    time: '2022-12-01',
    subTitle: '山东烟台安全生产监管平台项目',
    content: '平台能够为政府监管部门及人员提供多样性可视化数据，通过监管一张图模块、辅助决策平台模块、视频监控预警平台模块、企业档案管理模块、数据汇总模块形成统一的针对危险化学品管控、安全生产综合监管与应急救援服务结合的安全监管。' ,
    list: [
      {
        type: 'content',
        list: [
          '政府（园区）监管平台能够为政府监管部门及人员提供多样性可视化数据，通过监管一张图模块、辅助决策平台模块、视频监控预警平台模块、企业档案管理模块、数据汇总模块形成统一的针对危险化学品管控、安全生产综合监管与应急救援服务结合的安全监管。'
        ]
      },
      {
        type: 'img',
        imgType: 1,
        colSpan: 24,
        gutter: 0,
        list: [
          '/images/case/case-5-sdyt/1.png',
          '/images/case/case-5-sdyt/2.png'
        ]
      }
    ]
  },
  {
    type: 3,
    title: '山东宇世巨化工有限公司企业安全生产平台',
    img: '/images/menu/B6-bg.png',
    icon: '/images/case/icon/icon-6.png',
    area: '山东·德州',
    time: '2022-10-13',
    subTitle: '山东宇世巨化工有限公司企业安全生产平台',
    content: '山东宇世巨化工有限公司是一家生产酚醛树脂的综合性化工企业。年酚醛树脂生产能力20万吨，主要生产磨料磨具、摩擦材料、铸造覆膜砂、耐火材料、电子树脂、建筑保温材料用酚醛树脂等。化工企业安全生产平台提高宇世巨化工园区产业安全管理水平，实现重大危险源监测、自动化、智能化风险预警，降低化工企业生产安全事故发生概率，有效降低危化品的安全事故风险。' ,
    list: [
      {
        type: 'content',
        list: [
          '山东宇世巨化工有限公司是一家生产酚醛树脂的综合性化工企业。年酚醛树脂生产能力20万吨，主要生产磨料磨具、摩擦材料、铸造覆膜砂、耐火材料、电子树脂、建筑保温材料用酚醛树脂等。化工企业安全生产平台提高宇世巨化工园区产业安全管理水平，实现重大危险源监测、自动化、智能化风险预警，降低化工企业生产安全事故发生概率，有效降低危化品的安全事故风险。'
        ]
      },
      {
        type: 'img',
        imgType: 1,
        colSpan: 24,
        gutter: 0,
        list: [
          '/images/case/case-6-sdysj/1.png',
        ]
      }
    ]
  }
]

export const newCaseList2 = [
  {
    name: '贵溪硫磷化工基地',
    typeName: '化工园区',
    img: '/images/case2/1-1.png',
    des: '入选江西省第一批认定化工园区名单'
  },
  {
    name: '库车经开区化工园区',
    typeName: '化工园区',
    img: '/images/case2/1-2.png',
    des: '阿克苏地区重点园区'
  },
  {
    name: '阜阳颍东化工园区',
    typeName: '化工园区',
    img: '/images/case2/1-3.png',
    des: '安徽省第一批化工园区'
  },
  {
    name: '自贡川南新材料化工园区',
    typeName: '化工园区',
    img: '/images/case2/1-4.png',
    des: '中国先进氟材料示范园区'
  },
  {
    name: '安庆桐城化工园区',
    typeName: '化工园区',
    img: '/images/case2/1-5.png',
    des: '新一代信息技术产业园区'
  },
  {
    name: '亳州涡阳化工园区',
    typeName: '化工园区',
    img: '/images/case2/1-6.png',
    des: '安徽绿色化工精品园区'
  },
  {
    name: '泰和安智慧工厂',
    typeName: '智慧工厂',
    img: '/images/case2/2-1.png',
    des: '一流的防火产品及服务提供商'
  },
  {
    name: '江西中科冠物联网科技有限公司',
    typeName: '智慧工厂',
    img: '/images/case2/2-2.png',
    des: '城市公共安全一站式全场景服务商'
  },
  {
    name: '山东烟台安全生产监管平台项目',
    typeName: '化工企业',
    img: '/images/case2/3-1.png',
    des: '全过程、全方位的安全防控体系'
  },
  {
    name: '山东宇世巨化工有限公司',
    typeName: '化工企业',
    img: '/images/case2/3-2.png',
    des: '生产酚醛树脂的综合性化工企业，科技创新成果80多项'
  },
  {
    name: '山东凯瑞英材料科技有限公司',
    typeName: '化工企业',
    img: '/images/case2/3-3.png',
    des: '以技术进步为核心驱动力的生产公司'
  },
  {
    name: '乐陵力拓化学品有限责任公司',
    typeName: '化工企业',
    img: '/images/case2/3-4.png',
    des: '以化学油品销售为主的公司'
  },
  {
    name: '烟台安诺其精细化工有限公司',
    typeName: '化工企业',
    img: '/images/case2/3-5.png',
    des: '终端品牌，自创品牌'
  },
  {
    name: '莱州市金诚橡胶有限公司',
    typeName: '化工企业',
    img: '/images/case2/3-6.png',
    des: '资深橡胶密封件生产企业'
  },
  {
    name: '龙口科达化工有限公司',
    typeName: '化工企业',
    img: '/images/case2/3-7.png',
    des: '二溴海因、二氯海因和溴氯海因中国国家标准起草单位'
  },
  {
    name: '蓬莱红卫化工有限公司',
    typeName: '化工企业',
    img: '/images/case2/3-8.png',
    des: '打破国外垄断，实现抗氧剂HW-245、AO-80国产化'
  },
  {
    name: '海利贵溪新材料科技有限公司',
    typeName: '化工企业',
    img: '/images/case2/3-9.png',
    des: '海利贵溪“3000t/a甲基嘧啶磷生产装置”建成投产'
  },
  {
    name: '江西晨隆科技有限公司',
    typeName: '化工企业',
    img: '/images/case2/3-10.png',
    des: '有机玻璃专业生产厂家'
  },
  {
    name: '江西吉人高新材料有限公司',
    typeName: '化工企业',
    img: '/images/case2/3-11.png',
    des: '高新材料专家'
  },
  {
    name: '涡阳县华夏气体有限公司',
    typeName: '化工企业',
    img: '/images/case2/3-12.png',
    des: '工业气体最优秀的专业供应商'
  },
  {
    name: '阿克苏华锦化肥有限责任公司',
    typeName: '化工企业',
    img: '/images/case2/3-13.png',
    des: '华锦牌尿素，荣获“中国名牌”产品称号'
  },
  {
    name: '中国石化塔河炼化有限责任公司',
    typeName: '化工企业',
    img: '/images/case2/3-14.png',
    des: '中国石化西部炼化企业桥头堡'
  },
  {
    name: '中石化阿克苏石油分公司库车团结油库',
    typeName: '化工企业',
    img: '/images/case2/3-15.png',
    des: '从事油气储运、加油加注、润滑油销售'
  },
  {
    name: '库车文景油气化工有限公司',
    typeName: '化工企业',
    img: '/images/case2/3-16.png',
    des: '提供完整 LNG 生产、储存、销售、运输为一体的高品质民营企业'
  },
  {
    name: '库车中原石油化工有限公司',
    typeName: '化工企业',
    img: '/images/case2/3-17.png',
    des: '国家"八五"重点建设项目'
  },
  {
    name: '安徽中核桐源科技有限公司',
    typeName: '化工企业',
    img: '/images/case2/3-18.png',
    des: '一直专注于呼气检测技术的应用与创新'
  },
  {
    name: '安徽中环环保科技股份有限公司桐城市分公司',
    typeName: '化工企业',
    img: '/images/case2/3-19.png',
    des: '安徽省环保产业骨干企业和优秀企业'
  }
]

export const newCaseList = [
  {
    name: '文物古建筑防火案例',
    typeName: '',
    img: '/images/case3/1.jpg',
    des: '贵州省遵义市务川县'
  },
  {
    name: '金融行业智慧消防案例',
    typeName: '',
    img: '/images/case3/2.jpg',
    des: '天津市区农商银行营业网点-天津农商银行'
  },
  {
    name: '住宅单位智慧消防案例',
    typeName: '',
    img: '/images/case3/3.png',
    des: '廊坊市区华夏幸福物业住宅小区-华夏幸福行业单位联网'
  },
  {
    name: '养老场所智慧消防案例',
    typeName: '',
    img: '/images/case3/4.png',
    des: '潍坊市寒亭区朱里街道前朱里村-潍坊市寒亭区朱里益寿园托老中心'
  },
  {
    name: '校园智慧消防案例',
    typeName: '',
    img: '/images/case3/5.jpg',
    des: '四川省乐山市-乐山师范学院'
  },
  {
    name: '工地智慧防火案例',
    typeName: '',
    img: '/images/case3/6.png',
    des: '深圳市-红土创新广场'
  },
  {
    name: '工业园区防火案例',
    typeName: '',
    img: '/images/case3/7.png',
    des: '广东省深圳市-1970创意文化产业园'
  },
  {
    name: '九小场所防火案例',
    typeName: '',
    img: '/images/case3/8.png',
    des: '河北省石家庄-石家庄润丰五金城'
  },
  {
    name: '城中村智慧防火案例',
    typeName: '',
    img: '/images/case3/9.png',
    des: '广东省深圳市-深圳市新和社区'
  }
]


// WEBPACK FOOTER //
// ./src/views/case/caseInfo.js